/** @typedef {import('../types/finance').Fee} Fee */
/** @typedef {import('../types/finance').MerchantFee} MerchantFee */
/** @typedef {import('../types/api').ApiResponse} ApiResponse */

import { instance } from '../config';

/**
 * @param {string} feeType
 * @param {string} [merchant_name]
 * @returns {Promise<ApiResponse<Fee[]>>}
 */
const fetchFees = async (feeType, merchant_name) => {
  let url = `/fees/${feeType}`;

  if (merchant_name) {
    url += `?merchant_name=${merchant_name}`;
  }

  const { data } = await instance.get(url);
  return data;
};

/**
 * @param {string} feeType
 * @returns {Promise<ApiResponse<MerchantFee>>}
 */
const fetchFeesMerchant = async (feeType) => {
  let url = `/fees/?type=${feeType}`;
  const { data } = await instance.get(url);
  return data;
};

/** @returns {Promise<ApiResponse<string[]>>} */
const fetchFeeTypes = async () => {
  const { data } = await instance.get('/fees-types');
  return data;
};

/**
 * @param {Partial<Fee>} payload
 * @returns {Promise<ApiResponse<Fee>>}
 */
const createFee = async (payload) => {
  const { data } = await instance.post('/fees', payload);
  return data;
};

/**
 * @param {Fee & { id: number }} payload
 * @returns {Promise<ApiResponse<Fee>>}
 */
const updateFee = async (payload) => {
  const { data } = await instance.patch(`/fees/${payload.id}`, payload);
  return data;
};

export { createFee, fetchFees, fetchFeesMerchant, fetchFeeTypes, updateFee };
